import {Component} from '@angular/core';
import {Router, ActivatedRoute, NavigationEnd} from '@angular/router';
import 'rxjs/add/operator/filter';

@Component({
  selector: 'breadcrumbs',
  template: `
    <ng-template ngFor let-breadcrumb [ngForOf]="breadcrumbs" let-last=last>
      <li class="breadcrumb-item" *ngIf="breadcrumb.label.title" [ngClass]="{active: last}">
        <a *ngIf="!last" [routerLink]="breadcrumb.url">{{breadcrumb.label.title | translate}}</a>
        <span *ngIf="last">{{breadcrumb.label.title | translate}}</span>
      </li>
    </ng-template>`
})
export class BreadcrumbsComponent {
  breadcrumbs: Array<Object>;

  constructor(private router: Router, private route: ActivatedRoute) {
    this.router.events.filter(event => {
      return event instanceof NavigationEnd;
    }).subscribe(event => {
      this.breadcrumbs = [];
      let currentRoute = this.route.root,
        url = '';
      do {
        let childrenRoutes = currentRoute.children;
        currentRoute = null;
        childrenRoutes.forEach(route => {
          if (route.outlet === 'primary' && route.snapshot.data && route.snapshot.data['title']) {
            let routeSnapshot = route.snapshot;
            url += '/' + routeSnapshot.url.map(segment => segment.path).join('/');

            this.breadcrumbs.push({
              label: route.snapshot.data,
              url: url
            });
            currentRoute = route;
          }
        })
      } while (currentRoute);
    })
  }
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/roche/roche/src/app/shared/breadcrumb.component.ts